// CHECKPOINT-75: turns the live Identity password rules (from the API) into
// human-readable instructions and a client-side pre-check. The server always has
// the final say — this is just instant feedback so errors show inside the dialog.

// Evaluate each active rule against the current password.
// Returns [{ label, met }] — drives the live ✓/✗ checklist.
export function evaluateRules(password, rules) {
    if (!rules) return [];
    const pw = password || '';
    const checks = [];
    checks.push({ label: `At least ${rules.requiredLength} characters`, met: pw.length >= rules.requiredLength });
    if (rules.requireUppercase) checks.push({ label: 'One uppercase letter (A–Z)', met: /[A-Z]/.test(pw) });
    if (rules.requireLowercase) checks.push({ label: 'One lowercase letter (a–z)', met: /[a-z]/.test(pw) });
    if (rules.requireDigit) checks.push({ label: 'One number (0–9)', met: /[0-9]/.test(pw) });
    if (rules.requireNonAlphanumeric) checks.push({ label: 'One special character (e.g. @ # !)', met: /[^a-zA-Z0-9]/.test(pw) });
    if (rules.requiredUniqueChars > 1) {
        checks.push({ label: `At least ${rules.requiredUniqueChars} different characters`, met: new Set(pw.split('')).size >= rules.requiredUniqueChars });
    }
    return checks;
}

// Build the "must contain…" instruction lines (labels only).
export function describeRules(rules) {
    return evaluateRules('', rules).map(c => c.label);
}

// Returns an array of failing-rule messages ([] means it passes the client check).
export function validatePassword(password, rules) {
    const pw = password || '';
    const errors = [];
    if (!rules) {
        // No rules loaded yet — don't block; the server will validate.
        if (!pw) errors.push('Password is required.');
        return errors;
    }
    if (pw.length < rules.requiredLength) errors.push(`Must be at least ${rules.requiredLength} characters.`);
    if (rules.requireUppercase && !/[A-Z]/.test(pw)) errors.push('Must include an uppercase letter.');
    if (rules.requireLowercase && !/[a-z]/.test(pw)) errors.push('Must include a lowercase letter.');
    if (rules.requireDigit && !/[0-9]/.test(pw)) errors.push('Must include a number.');
    if (rules.requireNonAlphanumeric && !/[^a-zA-Z0-9]/.test(pw)) errors.push('Must include a special character.');
    if (rules.requiredUniqueChars > 1 && new Set(pw.split('')).size < rules.requiredUniqueChars) {
        errors.push(`Must contain at least ${rules.requiredUniqueChars} different characters.`);
    }
    return errors;
}
